<template>
  <div class="activity-wrap">
    <div class="activity-con">
      <div class="time">活动时间： 8月17日 - 8月31日</div>
      <h2 class="title">活动内容</h2>
      <div class="con">
        购买大智慧365、大智慧专业版产品享受8折优惠，大智慧365可获得热点轮动(旧版)功能，大智慧专业版可获得热点狙击功能。
      </div>
      <p class="product-text">活动产品：
        <router-link :to="{name: 'Product', params: {id: 116 }}" target="_blank">《大智慧365》</router-link>、
        <router-link :to="{name: 'Product', params: {id: 73}}" target="_blank">《大智慧专业版》</router-link>
      </p>
      <h2 class="title">活动范围</h2>
      <div class="con">
        以上产品的年卡、双年卡参与本次活动，月卡、季卡均不参与活动，大智慧策略投资终端、大智慧财富版、大智慧港股通专业版不参与活动。
      </div>
      <div class="item">
        <h3>《热点狙击》狙击市场热点，梳理市场风向（专业版）。</h3>
        <img src="../../assets/images/activity/202008/img1.jpg" alt="">
        <img src="../../assets/images/activity/202008/img2.jpg" alt="">
        <a class="btn-buy" target="_blank" @click="goUrl(73)">立即购买</a>
      </div>
      <div class="item">
        <h3>《热点轮动》推演近期热点板块的轮动轨迹，并快速定位龙头股。（旧版）大智慧365版本。</h3>
        <img src="../../assets/images/activity/202008/img3.jpg" alt="">
        <a class="btn-buy" target="_blank" @click="goUrl(116)">立即购买</a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data: function () {
    return {
      token: ''
    }
  },
  created() {
    var token = this.$route.query.token;
    if (token) {
      this.token = token;
    }
  },
  methods: {
    goUrl (key) {
      let routerDate;
      if (this.token) {
        routerDate = this.$router.resolve({name: 'ClientProduct', query: {token: this.token, pid: key}})
      } else {
        routerDate = this.$router.resolve({name: 'OrderConfirm', params:{productId: key}})
      }
      let {href} = routerDate
      window.open(href, "_blank")
    }
  }
}
</script>

<style lang="scss" scoped>
.activity-wrap{
  background:url(~@/assets/images/activity/202008/bg1.jpg) no-repeat center top,
    url(~@/assets/images/activity/202008/bg2.jpg) no-repeat center 687px,
    url(~@/assets/images/activity/202008/bg3.jpg) no-repeat center 1278px,
    url(~@/assets/images/activity/202008/bg4.jpg) no-repeat center 1883px,
    url(~@/assets/images/activity/202008/bg5.jpg) no-repeat center 3171px, #d3e1ff;
    padding-bottom: 77px;
    .activity-con{
      @include auto(1200px);
      padding-top: 588px;
    }
    .time{
      @include wh(621px, 101px);
      @include fc(40px, #fff);
      background: url(~@/assets/images/activity/202008/time-bg.png) no-repeat;
      line-height: 90px;
      margin: 0 auto 83px;
      text-align: center;
    }
    .title{
      @include wh(1200px, 102px);
      @include fc(48px, #fff);
      background: url(~@/assets/images/activity/202008/title.png) no-repeat;
      line-height: 102px;
      text-align: center;
      margin-bottom: 20px;
    }
    .con{
      @include wh(1200px, 401px);
      @include fc(40px, #fff);
      background: url(~@/assets/images/activity/202008/con-bg.png) no-repeat;
      line-height: 72px;
      padding: 80px 95px;
      box-sizing: border-box;
    }
    .product-text{
      @include fc(48px, #4157e5);
      padding-left: 100px;
      margin: 55px 0;
      a{
        color: #4157e5;
        text-decoration: underline;
      }
    }
    .item{
      background: #5b6ff0;
      border-radius: 20px;
      box-sizing: border-box;
      padding: 45px 50px 15px;
      margin-top: 56px;
      + .item{
        margin-top: 64px;
      }
      h3{
        @include fc(40px, #fff);
        text-align: center;
        line-height: 60px;
        margin-bottom: 40px;
      }
      img{
        width: 100%;
        display: block;
        +img{
          margin-top: 42px;
        }
      }
      .btn-buy{
        display: block;
        @include wh(370px, 103px);
        @include fc(40px, #fff);
        background: url(~@/assets/images/activity/202008/btn-buy.png) no-repeat;
        line-height: 90px;
        margin: 25px auto 0px;
        text-align: center;
      }
    }
}
</style>


// WEBPACK FOOTER //
// src/pages/activity/Summer202008.vue